import { render, staticRenderFns } from "./ChangeFinalAssetsPlatform.vue?vue&type=template&id=e0a9014c&scoped=true&"
import script from "./ChangeFinalAssetsPlatform.vue?vue&type=script&lang=js&"
export * from "./ChangeFinalAssetsPlatform.vue?vue&type=script&lang=js&"
import style0 from "./ChangeFinalAssetsPlatform.vue?vue&type=style&index=0&id=e0a9014c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a9014c",
  null
  
)

export default component.exports